

















import Vue from 'vue'

export default Vue.extend({
  name: 'SwitchEl',

  data: () => ({
    selected: false
  }),

  props: {
    templateItemData: {
      type: Object,
      required: true
    }
  }
})
